import { useState } from 'react';

/**
 * Pagination helper that keeps a fixed page size and increments the page when
 * the user clicks "Show more". It also exposes the total number of items the
 * UI intends to display (page * pageSize) so paired lists can size themselves.
 *
 * @param {{ initial?: number, step?: number, expanded?: number }} [sizes]
 * @returns {{ showAll: boolean, setShowAll: () => void, showMore: () => void, page: number, pageSize: number, totalVisible: number }}
 */
export default function useShowMorePagination(sizes = {}) {
  const { initial = 3 } = sizes;
  const [showAll, setShowAllInternal] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(initial);

  const showMore = () => setPage((p) => p + 1);
  const setShowAll = () => setShowAllInternal(true);

  const totalVisible = page * pageSize;

  return { showAll, setShowAll, showMore, page, pageSize, totalVisible };
}
